var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"whiteBox chartBox"},[_c('h4',[_vm._v("Amount orders")]),_c('br'),(_vm.amountOrdersChartData)?_c('BarChart',{attrs:{"height":300,"chartData":_vm.datacollection,"options":_vm.chartOptions}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }